import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiActivity, FiZap, FiTarget, FiTrendingUp } from 'react-icons/fi';

export default function MediaPlaceholder({ category, difficulty }) {
  const getColors = () => {
    switch(difficulty) {
      case 'Advanced': return 'from-red-500/20 to-carbon-900';
      case 'Intermediate': return 'from-blue-500/20 to-carbon-900';
      default: return 'from-lime-500/20 to-carbon-900';
    }
  };

  const getIcon = () => {
    switch(category) {
      case 'Strength': return FiTarget;
      case 'Cardio': return FiZap;
      case 'Hypertrophy': return FiActivity;
      default: return FiTrendingUp;
    }
  };

  return (
    <div className={`w-full h-full bg-gradient-to-br ${getColors()} relative overflow-hidden flex items-center justify-center group`}>
      {/* Background Kinetic Pattern */}
      <div className="absolute inset-0 opacity-10 group-hover:opacity-20 transition-opacity">
        <svg width="100%" height="100%">
          <pattern id="grid" width="20" height="20" patternUnits="userSpaceOnUse">
            <path d="M 20 0 L 0 0 0 20" fill="none" stroke="currentColor" strokeWidth="0.5" className="text-white" />
          </pattern>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>
      
      {/* Central Abstract Illustration */}
      <div className="relative z-10 flex flex-col items-center gap-2">
        <div className="w-16 h-16 rounded-full bg-carbon-800 border border-carbon-600 flex items-center justify-center shadow-2xl group-hover:scale-110 group-hover:border-lime-500/50 transition-all duration-500">
          <SafeIcon icon={getIcon()} className="text-3xl text-lime-500 text-glow" />
        </div>
        <div className="text-[10px] font-mono text-gray-500 uppercase tracking-widest">{category}_NODE</div>
      </div>

      {/* Motion Trails */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-lime-500/30 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />
      <div className="absolute bottom-0 right-0 w-full h-1 bg-gradient-to-r from-transparent via-lime-500/30 to-transparent translate-x-full group-hover:-translate-x-full transition-transform duration-1000 delay-150" />
    </div>
  );
}